// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__KO3Sv","log":"ModalInventoryLogs_log__2U57g","date":"ModalInventoryLogs_date___1o6I","userName":"ModalInventoryLogs_userName__QsI6G"};